import { Button, Drawer, Field, HStack, Icon, Input, Portal, Spinner, Text, VStack } from "@chakra-ui/react";
import { IoCloseSharp } from "react-icons/io5";
import { useState } from "react";
import UserService from "@/services/UserService";
import { showToast } from "@/components/ui/toaster";

const CreateUserDrawer = ({ isOpen, onClose, onCreated }) => {
    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    const handleClose = () => {
        setEmail("");
        setFirstName("");
        setLastName("");
        onClose();
    };

    const handleCreate = async () => {
        setIsSaving(true);
        try {
            // This panel manages CyberJob system admins only.
            await UserService.create({ email, firstName, lastName, role: "Admin" });
            showToast("User created", "Activation email sent", "success");
            onCreated();
            handleClose();
        } catch {
            showToast("Error", "Failed to create user", "error");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <Drawer.Root open={isOpen} onOpenChange={(e) => !e.open && handleClose()} size="md" placement="end">
            <Portal>
                <Drawer.Backdrop />
                <Drawer.Positioner padding="4">
                    <Drawer.Content bg="bg.drawer" borderRadius={16}>
                        <Drawer.Header>
                            <HStack justifyContent="space-between" w="full">
                                <Text color="white">Add User</Text>
                                <Icon fontSize={32} color="text.grey" onClick={handleClose} cursor="pointer">
                                    <IoCloseSharp />
                                </Icon>
                            </HStack>
                        </Drawer.Header>
                        <Drawer.Body>
                            <VStack gap={4} alignItems="flex-start" w="full">
                                <Field.Root required>
                                    <Field.Label color="white" fontSize={18}>
                                        Email <Field.RequiredIndicator />
                                    </Field.Label>
                                    <Input variant="primary" placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                </Field.Root>
                                <Field.Root required>
                                    <Field.Label color="white" fontSize={18}>
                                        First Name <Field.RequiredIndicator />
                                    </Field.Label>
                                    <Input variant="primary" placeholder="Enter first name" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                </Field.Root>
                                <Field.Root required>
                                    <Field.Label color="white" fontSize={18}>
                                        Last Name <Field.RequiredIndicator />
                                    </Field.Label>
                                    <Input variant="primary" placeholder="Enter last name" value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                </Field.Root>
                            </VStack>
                        </Drawer.Body>
                        <Drawer.Footer borderRadius={16}>
                            <HStack justifyContent="flex-end" w="full" gap={3}>
                                <Button variant="outlined" textDecoration="unset" onClick={handleClose} disabled={isSaving}>Cancel</Button>
                                <Button variant="primary" textDecoration="unset" onClick={handleCreate} disabled={isSaving}>
                                    {isSaving ? <Spinner size="sm" /> : "Create"}
                                </Button>
                            </HStack>
                        </Drawer.Footer>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Portal>
        </Drawer.Root>
    );
};

export default CreateUserDrawer;
